import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=28436f8e&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderSummary.vue?vue&type=style&index=1&id=28436f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28436f8e",
  null
  
)

export default component.exports